import { useState, useCallback, useMemo } from 'react';
import { notificacoesBackoffice } from '@/mocks/backoffice/notificacoes';

const STORAGE_KEY = 'notificacoes_lidas';

function getLidasInicial(): string[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {
    // ignore
  }
  return [];
}

function saveLidas(lidas: string[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lidas));
  } catch {
    // ignore
  }
}

export function useNotificacoes() {
  const [lidas, setLidas] = useState<string[]>(getLidasInicial);
  const [notifOpen, setNotifOpen] = useState(false);

  const notificacoes = useMemo(() => {
    return notificacoesBackoffice.map((n) => ({
      ...n,
      lida: lidas.includes(n.id),
    }));
  }, [lidas]);

  const naoLidas = useMemo(
    () => notificacoes.filter((n) => !n.lida),
    [notificacoes]
  );

  const criticos = useMemo(
    () => naoLidas.filter((n) => n.tipo === 'critico'),
    [naoLidas]
  );

  const marcarComoLida = useCallback((id: string) => {
    setLidas((prev) => {
      if (prev.includes(id)) return prev;
      const next = [...prev, id];
      saveLidas(next);
      return next;
    });
  }, []);

  const marcarTodasComoLidas = useCallback(() => {
    const todas = notificacoesBackoffice.map((n) => n.id);
    setLidas(todas);
    saveLidas(todas);
  }, []);

  const abrirNotificacoes = useCallback(() => {
    setNotifOpen((prev) => !prev);
  }, []);

  const fecharNotificacoes = useCallback(() => {
    setNotifOpen(false);
  }, []);

  return {
    notificacoes,
    naoLidas,
    criticos,
    totalNaoLidas: naoLidas.length,
    totalCriticos: criticos.length,
    marcarComoLida,
    marcarTodasComoLidas,
    notifOpen,
    abrirNotificacoes,
    fecharNotificacoes,
  };
}